const CART_DRAWER_OPEN_CLASS = 'is-active';

function formatMoney(cents) {
  const symbol = window.themeCurrencySymbol || 'TL';
  const amount = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  if (symbol === '₺' || symbol === 'TL') {
    return amount + ' ' + symbol;
  }
  return symbol + amount;
}

function openCartDrawer() {
  document.getElementById('CartDrawer').classList.add(CART_DRAWER_OPEN_CLASS);
  document.getElementById('CartDrawerOverlay').classList.add(CART_DRAWER_OPEN_CLASS);
}

function closeCartDrawer() {
  document.getElementById('CartDrawer').classList.remove(CART_DRAWER_OPEN_CLASS);
  document.getElementById('CartDrawerOverlay').classList.remove(CART_DRAWER_OPEN_CLASS);
}

function updateFreeShipping(totalPrice) {
  const shippingContainer = document.getElementById('CartDrawerFreeShipping');
  if (!shippingContainer) return;

  const symbol = window.themeCurrencySymbol || 'TL';
  let threshold = parseInt(shippingContainer.getAttribute('data-threshold')) || 5000;
  if (symbol === '₺' || symbol === 'TL') {
    threshold = 100000;
  }

  const textEl = document.getElementById('FreeShippingText');
  const progressEl = document.getElementById('FreeShippingProgress');

  if (totalPrice >= threshold) {
    textEl.textContent = "Tebrikler! Ücretsiz kargo kazandınız! 🎉";
    progressEl.style.width = '100%';
  } else {
    const remaining = threshold - totalPrice;
    textEl.textContent = `Ücretsiz kargo için kalan tutar: ${formatMoney(remaining)}!`;
    const percent = Math.min((totalPrice / threshold) * 100, 100);
    progressEl.style.width = percent + '%';
  }
}

function updateCartCount(count) {
  const cartLinks = document.querySelectorAll('a[href="/cart"]');
  cartLinks.forEach(link => {
    let sup = link.querySelector('sup');
    if (count > 0) {
      if (!sup) {
        sup = document.createElement('sup');
        link.insertBefore(sup, link.firstChild);
      }
      sup.textContent = count;
    } else {
      if (sup) {
        sup.remove();
      }
    }
  });
}

function updateUpsellsList(cart) {
  const upsellItems = document.querySelectorAll('.cart-drawer-upsell-item');
  let visibleCount = 0;

  upsellItems.forEach(item => {
    const button = item.querySelector('[data-upsell-add]');
    if (!button) return;
    const variantId = parseInt(button.getAttribute('data-upsell-add'));
    const isInCart = cart.items.some(lineItem => lineItem.variant_id === variantId);

    if (isInCart) {
      item.style.display = 'none';
    } else {
      if (visibleCount < 2) {
        item.style.display = 'flex';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    }
  });

  const upsellsContainer = document.getElementById('CartDrawerUpsells');
  if (upsellsContainer) {
    if (visibleCount === 0) {
      upsellsContainer.style.display = 'none';
    } else {
      upsellsContainer.style.display = 'block';
    }
  }
}

function renderCart(cart) {
  const container = document.getElementById('CartDrawerItems');
  const subtotalEl = document.getElementById('CartDrawerSubtotal');

  if (!container) return;

  const footerEl = document.getElementById('CartDrawerForm');

  if (cart.item_count === 0) {
    container.innerHTML = `<div class="cart-drawer__empty"><p>Sepetiniz şu anda boş.</p></div>`;
    if (subtotalEl) subtotalEl.textContent = formatMoney(0);
    updateFreeShipping(0);
    updateCartCount(0);
    updateUpsellsList(cart);
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  let html = '';
  cart.items.forEach(item => {
    html += `
      <div class="cart-drawer-item" data-line-item-key="${item.key}">
        <div class="cart-drawer-item__image">
          <img src="${item.image || 'https://cdn.shopify.com/s/images/admin/no-image-large.gif'}" alt="${item.title}" loading="lazy">
        </div>
        <div class="cart-drawer-item__info">
          <h4 class="cart-drawer-item__title">${item.product_title}</h4>
          <div class="cart-drawer-item__meta">${item.variant_title || ''}</div>
          <div class="cart-drawer-item__price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-drawer-item__qty-wrapper">
            <button class="cart-drawer-item__qty-btn qty-minus" data-qty-change="-1" data-key="${item.key}" data-qty="${item.quantity}">-</button>
            <input type="number" class="cart-drawer-item__qty-input" value="${item.quantity}" min="0" readonly>
            <button class="cart-drawer-item__qty-btn qty-plus" data-qty-change="1" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  updateFreeShipping(cart.total_price);
  updateCartCount(cart.item_count);
  updateUpsellsList(cart);
}

function fetchCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      renderCart(cart);
    });
}

function addToCart(variantId, quantity = 1) {
  const data = {
    id: variantId,
    quantity: quantity
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(() => {
      fetchCart();
      openCartDrawer();
    });
}

function changeQuantity(key, quantity) {
  const data = {
    id: key,
    quantity: quantity
  };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(cart => {
      renderCart(cart);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  fetchCart();

  const cartLinks = document.querySelectorAll('a[href="/cart"]');
  cartLinks.forEach(link => {
    link.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      openCartDrawer();
    });
  });

  const closeBtn = document.getElementById('CartDrawerClose');
  const overlay = document.getElementById('CartDrawerOverlay');

  if (closeBtn) {
    closeBtn.addEventListener('click', closeCartDrawer);
  }
  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }

  document.addEventListener('submit', e => {
    const form = e.target;
    if (form.id === 'CartDrawerForm') {
      const agreeSales = document.getElementById('AgreeSalesAgreement');
      const agreePre = document.getElementById('AgreePreInfoForm');
      if (agreeSales && !agreeSales.checked) {
        alert("Lütfen devam etmeden önce Mesafeli Satış Sözleşmesi'ni okuyup onaylayın.");
        e.preventDefault();
        return;
      }
      if (agreePre && !agreePre.checked) {
        alert("Lütfen devam etmeden önce Ön Bilgilendirme Formu'nu okuyup onaylayın.");
        e.preventDefault();
        return;
      }
    } else if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;
      addToCart(variantId, quantity);
    }
  });

  const cartContainer = document.getElementById('CartDrawer');
  if (cartContainer) {
    cartContainer.addEventListener('click', e => {
      if (e.target.classList.contains('qty-minus')) {
        const key = e.target.getAttribute('data-key');
        const currentQty = parseInt(e.target.getAttribute('data-qty'));
        changeQuantity(key, currentQty - 1);
      } else if (e.target.classList.contains('qty-plus')) {
        const key = e.target.getAttribute('data-key');
        const currentQty = parseInt(e.target.getAttribute('data-qty'));
        changeQuantity(key, currentQty + 1);
      } else if (e.target.hasAttribute('data-upsell-add')) {
        const variantId = e.target.getAttribute('data-upsell-add');
        addToCart(variantId, 1);
      }
    });
  }
});
